<template>
    <div class="truncate mt-2">
        <Checkbox
            v-model="item.value"
            :name="`parameter_${parameter.idParameter}_value_${item.id}`"
            :label="item.name"
            :is-detail="isDetail"
            variant="outline"
            class="w-full"
        />
    </div>
  </template>

  <script setup>
  import _ from 'lodash-es';
  import Checkbox from "@components/ui/checkbox";

  const emit = defineEmits(['changed']);

  const props = defineProps({
    parameter: {
        type: Object,
        required: true
    },
    item: {
      type: Object,
      required: true
    },
    isDetail: {
      type: Boolean,
      default: false
    }
  });

  watch(() => props.item.value, (value) => {
    emit('changed', value);
  });

  </script>
